<template>
  <div class="popupbox">
    <div class="area-group message">
      {{ $t('idFindForm.noticeMessage') }}
    </div>
    <tab class="tab" :items="tabItem" :index.sync="tabIdx">
      <template v-slot:tab-page-0>
        <div class="inputBox">
          <table>
            <tr>
              <td><label for="userNm">{{ $t('idFindForm.inputName') }}</label></td>
              <td><input id="userNm" type="text" v-model="userNm"/></td>
            </tr>
            <tr>
              <td><label for="phone">{{ $t('idFindForm.inputPhone') }}</label></td>
              <td><input id="phone" type="text" v-model="phone" @input="onlyNumbers('phone')"/></td>
            </tr>
            <tr class="validatonText">
              <td></td>
              <td>
                <p v-show="!isValidPhone">{{ $t('idFindForm.inputPhoneValid') }}</p>
              </td>
            </tr>
          </table>
          <div>
            <button @click="reqCert" :disabled="!canReqCert">
              {{ $t('idFindForm.btnSubmit') }}
              <template v-if="coolTime > 0">
                <br>({{ coolTime }})
              </template>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:tab-page-1>
        <div class="inputBox">
          <table class="inputTable">
            <tr>
              <td><label for="userNm">{{ $t('idFindForm.inputName') }}</label></td>
              <td><input id="userNm" type="text" v-model="userNm"/></td>
            </tr>
            <tr>
              <td><label for="email">{{ $t('idFindForm.inputEmail') }}</label></td>
              <td><input id="email" type="text" v-model="email"/></td>
            </tr>
            <tr class="validatonText">
              <td></td>
              <td>
                <p v-show="!isValidEmail">{{ $t('idFindForm.inputEmailValid') }}</p>
              </td>
            </tr>
          </table>
          <div>
            <button @click="reqCert" :disabled="!canReqCert">
              {{ $t('idFindForm.btnSubmit') }}
              <template v-if="coolTime > 0">
                <br>({{ coolTime }})
              </template>
            </button>
          </div>
        </div>
      </template>
    </tab>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import * as AuthApi from '@/api/auth';
import * as StringUtil from '@/utils/stringUtil';
import Tab from '@/components/Tab.vue';

export default {
  name: 'IdFindForm',
  components: {
    Tab,
  },
  props: {
  },
  data: () => ({
    tabIdx: 0,
    userNm: '',
    phone: '',
    email: '',
    tabItem: [],
    coolTime: 0,
  }),
  methods: {
    reqCert(){
      if(!this.canReqCert) return;
      let prom = null;

      this.popWait();

      if(this.tabIdx === 0){
        prom = AuthApi.findIdFromPhone(this.userNm, this.phone);
      } else if(this.tabIdx === 1){
        prom = AuthApi.findIdFromEmail(this.userNm, this.email);
      } else {
        prom = Promise.reject(-1);
      }

      prom.then((e) => {
        if(e.status === 200){
          if((e.data) === '0000'){
            this.popAlert({
              code: 'idFindForm.message.success',
              field: [
                this.$t(this.tabIdx === 0 ? 'idFindForm.inputPhone' : 'idFindForm.inputEmail')
              ],
            }).then(() => {
              this.$emit('success');
            })
          } else {
            switch (e.data) {
              case '0001': // 유저없음
                this.popAlert('idFindForm.message.idNotFound');
                break;
              case '0002': // 발신실패-SMS
                this.popAlert('idFindForm.message.postSMSFailed');
                break;
              case '0003': // 발신실패-EMAIL
                this.popAlert('idFindForm.message.postEmailFailed');
                break;
              default:
                this.popAlert('idFindForm.message.defaultErr');
            }
          }
        } else {
          return Promise.reject('-1');
        }
      })
      .catch(() => {
        this.popAlert('idFindForm.message.defaultErr');
      })
      .finally(() => {
        this.stopWait();
      })
    },
    onlyNumbers: function(target){
      this[target] = this[target].replace(/[^0-9]/g, '');
    },
    ...mapActions([
      'popAlert',
      'popWait',
      'stopWait',
    ]),
  },
  computed: {
    canReqCert(){
      if(this.userNm === null || this.userNm === undefined || this.userNm === ''){
        return false;
      }

      if(this.tabIdx === 0){
        if(this.phone === null || this.phone === undefined || this.phone === ''){
          return false;
        }
        if(!this.isValidPhone) return false;
      } else if (this.tabIdx === 1){
        if(this.email === null || this.email === undefined || this.email === ''){
          return false;
        }
        if(!this.isValidEmail) return false;
      } else {
        return false;
      }

      if(this.coolTime > 0) return false;

      return true;
    },
    isValidPhone(){
      return StringUtil.isMobile(this.phone);
    },
    isValidEmail(){
      return StringUtil.isEmail(this.email);
    },
  },
  created(){
    this.tabItem = [
      {title: this.$t('idFindForm.tab[0]')},
      {title: this.$t('idFindForm.tab[1]')},
    ];
  }
};
</script>
<style lang="scss" scoped>
  $breakpoint: 500px;

  .popupbox {
    min-width: 350px;
    padding: 20px;
  }
  .message{
    padding: 10px;
    background-color: #edf7da;
    border: 1px solid #cbdda6;
    font-size: 14px;
    white-space: pre-line;
    margin-bottom: 20px;
  }

  .inputBox {
    display: flex;
    margin: 5px;
    padding: 10px;

    @media (max-width: $breakpoint) {
      flex-direction: column;
    }

    table {
      flex: 1 1 auto;
      td {
        padding: 5px;
      }

      .validatonText{
        td {
          padding-top: 0px;
          padding-bottom: 0px;
        }
      }

      input {
        min-height: 30px;
        width: 100%;
      }
      p {
        color: #ff0000;
        font-size: 12px;
      }

      @media (max-width: $breakpoint) {
        display: inline-block;
        tr {
          display: flex;
          flex-direction: column;
        }
      }
    }

    button {
      background-color: #0059a9;
      padding: 10px;
      margin-top: 6px;
      font-size: 16px;
      color: #fff;
      width: 100%;
      height: 72px;
      &:disabled {
        background-color: #eee;
        color: #555;
      }
      @media (max-width: $breakpoint) {
        height: 100%;
        padding: 5px;
      }
    }
  }
</style>
